import React, { useEffect } from "react";

import DocumentPicker from "EmployerApplication/Components/DocumentPicker";
import SuccessModal from "EmployerApplication/Components/documentPicker/SuccessModal";
import { parseDocType } from "EmployerApplication/Components/documentPicker/utils";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Row, Col } from "Common/Grid";

export const DocumentCardsSection = ({
  uploadDocsProps,
  showWageDocumentPicker,
  onDocumentUpload,
  onDocumentUploadSuccess,
  onWageDocumentUpload,
  validateEmployerApplicationDocument,
  showWhyRequired = false,
}) => {
  return (
    <Row>
      <Col md={12}>
        {uploadDocsProps.map((props, index) => {
          const isStateWageReport = parseDocType(props.fileInputName) == "state_wage_report";

          if (isStateWageReport && showWageDocumentPicker) {
            return (
              // Use the documents filename in the key prop for more stable
              // component cleanup
              <div key={`${props.fileInputName}_${index}`}>
                <DocumentPicker
                  {...props}
                  index={index}
                  onDocumentUpload={onWageDocumentUpload}
                  onDocumentUploadSuccess={onDocumentUploadSuccess}
                  validateDocument={validateEmployerApplicationDocument}
                  showWhyRequired={showWhyRequired}
                />

                <SuccessModal />
              </div>
            );
          }
          return (
            <div key={`${props.fileInputName}_${index}`}>
              <DocumentPicker
                {...props}
                index={index}
                onDocumentUpload={onDocumentUpload}
                onDocumentUploadSuccess={onDocumentUploadSuccess}
                validateDocument={validateEmployerApplicationDocument}
                showWhyRequired={showWhyRequired}
              />
            </div>
          );
        })}
      </Col>
    </Row>
  );
};
